import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';
import { of, type Observable } from 'rxjs';

import type { GridConfig } from './contracts/data-grid-config.interface';
import { GRID_CONFIG_SOURCE, type GridConfigSource } from './contracts/grid-config-source.interface';

/** Empty grid config for hosts that supply columns via component inputs. */
export const EMPTY_GRID_CONFIG: GridConfig = {
  sharedColumns: [],
  sharedColumnOrder: [],
  discriminatorColumns: {},
  discriminatorColumnOrder: {},
  defaultHiddenColumns: [],
  discriminatorColors: {},
  discriminatorLabels: {},
  groupableFields: [],
  remappingLookup: new Map<string, string>(),
  columnRemappings: []
};

/** Grid config source backed by a fixed in-memory config (no network). */
export class StaticGridConfigSource implements GridConfigSource {
  public readonly config$: Observable<GridConfig>;

  constructor(config: GridConfig = EMPTY_GRID_CONFIG) {
    this.config$ = of(config);
  }
}

/** Registers a static {@link GridConfigSource} with optional partial overrides.
 * Merge is shallow — pass complete nested fields (e.g. `discriminatorColumns`, `remappingLookup`) when overriding.
 */
export function provideStaticGridConfig(config?: Partial<GridConfig>): EnvironmentProviders {
  const merged: GridConfig = { ...EMPTY_GRID_CONFIG, ...config };
  return makeEnvironmentProviders([
    StaticGridConfigSource,
    {
      provide: GRID_CONFIG_SOURCE,
      useFactory: (): StaticGridConfigSource => new StaticGridConfigSource(merged)
    }
  ]);
}
